import { useApi } from './api';
import { useCallback } from 'react';

export const useCatalogService = () => {
  const { apiFetch } = useApi();

  const getAllCatalogs = useCallback(async() => {
    console.log('🔄 Llamando a getAllCatalogs...');
    const res = await apiFetch('/catalogs'); // ✅ CAMBIADO: URL relativa
    console.log('📡 Respuesta de getAllCatalogs:', res);
    if(!res.ok) {
      console.error('❌ Error en getAllCatalogs:', res.status, res.statusText);
      throw new Error('No se pudieron obtener los catalogos');
    }
    const data = await res.json();
    console.log('📊 Datos de getAllCatalogs:', data);
    return data;
  }, [apiFetch]);

  // Obtener áreas de servicio (para tipos de especialistas)
  const getServiceAreas = async() => {
    const res = await apiFetch('/catalogs/service-areas');
    if(!res.ok) throw new Error('No se pudieron obtener las áreas de servicio');
    return res.json();
  };

  // Obtener especialidades
  const getSpecialties = async() => {
    console.log('🔵 [catalogService] getSpecialties - Llamando al endpoint GET /api/specialties...');
    const res = await apiFetch('/specialties'); // ✅ CORRECTO: Según especificación GET /api/specialties
    
    console.log('🔵 [catalogService] getSpecialties - Respuesta:', {
      ok: res.ok,
      status: res.status,
      statusText: res.statusText
    });
    
    if(!res.ok) {
      const errorText = await res.text();
      console.error('❌ [catalogService] getSpecialties - Error:', errorText);
      throw new Error('No se pudieron obtener las especialidades');
    }
    
    const data = await res.json();
    console.log('🔵 [catalogService] getSpecialties - Datos recibidos:', {
      count: data?.length || 0,
      data: data
    });
    
    return data;
  };

  // Obtener modalidades
  const getModalities = async() => {
    const res = await apiFetch('/catalogs/modalities');
    if(!res.ok) throw new Error('No se pudieron obtener las modalidades');
    return res.json();
  };

  // Obtener áreas de cobertura geográfica
  const getCoverageAreas = async() => {
    console.log('🔵 [catalogService] getCoverageAreas - Llamando al endpoint...');
    const res = await apiFetch('/coverage-areas');
    
    console.log('🔵 [catalogService] getCoverageAreas - Respuesta:', {
      ok: res.ok,
      status: res.status,
      statusText: res.statusText
    });
    
    if(!res.ok) {
      const errorText = await res.text();
      console.error('❌ [catalogService] getCoverageAreas - Error:', errorText);
      throw new Error('No se pudieron obtener las áreas de cobertura');
    }
    
    const data = await res.json();
    console.log('🔵 [catalogService] getCoverageAreas - Datos recibidos:', {
      count: data?.length || 0,
      data: data
    });
    
    return data;
  };

  return { 
    getAllCatalogs,
    getServiceAreas,
    getSpecialties,
    getModalities,
    getCoverageAreas
  };
};

